import { createRouter } from '@tanstack/react-router';
import { rootRoute } from './routes/root.tsx';
import { overviewRoute } from './routes/overview.tsx';
import { auditRoute } from './routes/audit.tsx';
import { productsRoute } from './routes/products.tsx';
import {
  productDetailRoute,
  productEnvironmentsRoute,
  productPlansRoute,
} from './routes/product-detail.tsx';
import { teamRoute } from './routes/team.tsx';
import { platformOrganizationsRoute, platformUsersRoute } from './routes/platform.tsx';
import {
  analyticsRoute,
  customersRoute,
  licensesRoute,
  settingsRoute,
  usageRoute,
} from './routes/resources.tsx';
import { accessDeniedRoute } from './routes/auth/access-denied.tsx';
import { authCallbackRoute } from './routes/auth/callback.tsx';
import { authErrorRoute } from './routes/auth/error.tsx';
import { loginRoute } from './routes/auth/login.tsx';
import {
  apiKeysRoute,
  developersIndexRoute,
  environmentsRoute,
  requestLogsRoute,
  sdksRoute,
  webhooksRoute,
} from './routes/developers.tsx';

/**
 * The route tree is declared in code rather than generated from the filesystem.
 * At this size the generated `routeTree.gen.ts` is a build artefact to keep in
 * sync and a diff nobody reads; an explicit tree is one file a reviewer can check
 * against the navigation.
 */
const routeTree = rootRoute.addChildren([
  // Authentication routes render outside the console shell.
  loginRoute,
  authCallbackRoute,
  authErrorRoute,
  accessDeniedRoute,

  overviewRoute,
  teamRoute,
  productsRoute,
  productDetailRoute,
  productEnvironmentsRoute,
  productPlansRoute,
  customersRoute,
  licensesRoute,
  usageRoute,
  analyticsRoute,
  developersIndexRoute,
  apiKeysRoute,
  webhooksRoute,
  requestLogsRoute,
  environmentsRoute,
  sdksRoute,
  platformOrganizationsRoute,
  platformUsersRoute,
  auditRoute,
  settingsRoute,
]);

export function createConsoleRouter() {
  return createRouter({
    routeTree,
    defaultPreload: 'intent',
    // Every route is a static page at this stage; scrolling back to the top on
    // navigation is what an operator expects from a console.
    scrollRestoration: true,
  });
}

export const router = createConsoleRouter();

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
